export default __webpack_public_path__ + "static/media/banner-background.0511a6b2.jpg";